import { __assign } from "tslib";
import React from 'react';
import ErrorBoundary from '.';
export function withErrorBoundary(Component) {
    var decorated = function (props) { return (React.createElement(ErrorBoundary, null,
        React.createElement(Component, __assign({}, props)))); };
    decorated.displayName = "withErrorBoundary(" + (Component.displayName ||
        'Component') + ")";
    return decorated;
}
//# sourceMappingURL=withErrorBoundary.js.map